import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { ClickCtaType, ClickCtaUxSource } from 'src/types/analytics';
import { GuideCards } from 'src/types/landing-page';
import Guides from './Guides';

export interface GuideSection {
  platform: PlatformType;
  browser: BrowserType;
  cards: GuideCards;
  allowEditor: boolean;
  onSignUp: Function;
}

const GuideSection = (props: GuideSection) => {
  const { platform, cards, allowEditor, onSignUp, browser } = props;
  const { heading, CTAText, CTAUrl, GuideCardItems } = cards;

  const handleOnClick = () => {
    const oa = CTAUrl ? new URL(CTAUrl).searchParams.get('oa') : undefined;
    onSignUp({
      ux_source: ClickCtaUxSource.WorkflowCard,
      type: ClickCtaType.ClickSignup,
      btn_position: 'Workflow Card',
      oa,
    });
  };

  return (
    <section
      className={ivclass(
        'sm:iv-pt-15 md:iv-pt-[90px] lg:iv-pt-10',
        'sm:iv-px-20 md:iv-px-25 lg:iv-px-40 xl:iv-px-40',
        'iv-pt-150 md:iv-pt-100 sm:iv-pt-75',
      )}
    >
      <div className={ivclass('iv-container', 'iv-mx-auto')}>
        <h2
          className={ivclass(
            'iv-mb-20 md:iv-mb-50 lg:iv-mb-40 xl:iv-mb-64',
            'iv-text-grey-85',
            'iv-text-center',
            'iv-text-heading-2xs md:iv-text-heading-2xl lg:iv-text-heading-2xl xl:iv-text-heading-4xl',
            'iv-font-extrabold',
          )}
        >
          {heading}
        </h2>
        <Guides
          guideCards={GuideCardItems}
          platform={platform}
          browser={browser}
        />
        <div
          className={ivclass(
            'md:iv-pt-[60px] lg:iv-pt-[60px] xl:iv-pt-80',
            'iv-text-center iv-w-full',
            'iv-hidden lg:iv-flex xl:iv-flex',
            'iv-justify-center iv-items-center iv-flex-col',
          )}
        >
          <button
            className={ivclass(
              'iv-flex',
              'iv-items-center',
              'iv-h-65',
              'iv-px-40',
              'iv-rounded-full',
              'iv-bg-blue hover:iv-bg-blue-strong iv-text-grey-0',
              'md:iv-text-body-3xl lg:iv-text-body-3xl xl:iv-text-body-3xl',
              'md:iv-m-body-3xl lg:iv-m-body-3xl xl:iv-m-body-3xl',
              'iv-font-bold',
            )}
            type="button"
            onClick={handleOnClick}
          >
            {CTAText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default GuideSection;
